import React, { Component } from 'react'
import { Field } from 'redux-form'
import {
  renderTextField,
  renderDateField
} from '../../../Forms/fieldRenderers'
import {
  required,
  getNumericValidator,
  isDecimal,
  comprobarPesos
} from '../../../Forms/fieldValidators'
import {
  EntityAutocomplete,
  LocalidadAutocomplete,
  Biotecnologia
} from '../../../Forms/SharedComponents/containers'

import { Row, Col } from 'react-bootstrap'

const numeric5 = getNumericValidator(5, 5)

class CamposIngresoCompleto2 extends Component {
  render () {
    return (
      <div>
        <Row>
          <Col md={6}>
            <Field
              name='codigoDeEmisionElectronica'
              type='text'
              label='C.E.E.'
              component={renderTextField}
              autoFocus={false}
            />
          </Col>
          <Col md={3}>
            <Field
              name='renspa'
              type='text'
              label='renspa'
              component={renderTextField}
              autoFocus={false}
            />
          </Col>
          <Col md={3}>
            <Field
              name='fechaDeVencimiento'
              type='text'
              label='Fecha vencimiento *'
              component={renderDateField}
              autoFocus
              validate={[required]}
              closeOnSelect
            />
          </Col>
        </Row>
        <hr />
        <Row>
          <Col md={6}>
            <EntityAutocomplete
              name='intermediario'
              label='Intermediario/Rte. Comercial Venta Secundaria 2'
              entity='cargador'
              required={false}
              placeholder='Intermediario - 19999999991'
            />
          </Col>
          <Col md={6}>
            <EntityAutocomplete
              name='mercadoATermino'
              label='Mercado a Termino'
              entity='cargador'
              required={false}
              placeholder='Mercado a termino - 19999999991'
            />
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <EntityAutocomplete
              name='vendedor'
              required={false}
              label='Representante Entregador'
              entity='vendedor'
              placeholder='Representante - 19999999991'
            />
          </Col>
          <Col md={6}>
            <EntityAutocomplete
              name='intermediarioFlete'
              required={false}
              label='Intermediario Flete'
              entity='transportista'
              placeholder='IntermediarioFlete - 19999999991'
            />
          </Col>
        </Row>
        <hr />
        <Row>
          <Col md={3}>
            <Field
              name='contrato'
              type='text'
              label='Contrato'
              component={renderTextField}
              autoFocus={false}
            />
          </Col>
          <Col md={3}>
            <Field
              name='pesoNeto'
              type='text'
              label='KGs Neto *'
              component={renderTextField}
              autoFocus={false}
              maxLength={5}
              disabled
              validate={[required, numeric5]}
              // normalize={chainedNormalizer(onlyNumbers, nDigitsLimiter(5))}
              placeholder='30000'
            />
          </Col>
          <Col md={3}>
            <Field
              name='pesoBruto'
              type='text'
              label='KGs Bruto *'
              maxLength={5}
              component={renderTextField}
              autoFocus={false}
              validate={[required, numeric5]}
              // normalize={chainedNormalizer(onlyNumbers, nDigitsLimiter(5))}
              placeholder='45000'
            />
          </Col>
          <Col md={3}>
            <Field
              name='pesoTara'
              type='text'
              label='KGs Tara *'
              maxLength={5}
              component={renderTextField}
              autoFocus={false}
              validate={[required, numeric5, comprobarPesos]}
              // normalize={chainedNormalizer(onlyNumbers, nDigitsLimiter(5))}
              placeholder='15000'
            />
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <Field
              name='establecimientoDeOrigen'
              type='text'
              label='Establecimiento'
              component={renderTextField}
              autoFocus={false}
            />
          </Col>
          <Col md={6}>
            <LocalidadAutocomplete />
          </Col>
        </Row>
        <Row>
          <Col md={2}>
            <Field
              name='acoplado'
              type='text'
              label='Acoplado *'
              validate={[required]}
              upperCase
              component={renderTextField}
              autoFocus={false}
              placeholder='AA111BB o AAA111'
            />
          </Col>
          <Col md={2}>
            <Field
              name='kmRecorridos'
              type='text'
              label='Kms recorridos *'
              component={renderTextField}
              autoFocus={false}
              validate={[required, isDecimal]}
              placeholder='241'
            />
          </Col>
          <Col md={2}>
            <Field
              name='tarifa'
              type='text'
              label='Tarifa *'
              component={renderTextField}
              autoFocus={false}
              validate={[required, isDecimal]}
              placeholder='241'
            />
          </Col>
          <Col md={2}>
            <Field
              name='tarifaReferencia'
              type='text'
              label='Tarifa ref. *'
              component={renderTextField}
              autoFocus={false}
              validate={[required, isDecimal]}
              placeholder='241'
            />
          </Col>
          <Col md={4}>
            <Biotecnologia />
          </Col>
        </Row>
        <Row>
          <Col md={12} style={{ textAlign: 'right', marginTop: '8px' }}>
            <p>(*) Campo requerido obligatorio</p>
          </Col>
        </Row>
      </div>
    )
  }
}

export default CamposIngresoCompleto2
